// MessageItem.js
import React from "react";

const MessageItem = ({ msg, me }) => {
  const isMe = msg.fromId === me;

  const getTime = () => {
    let t = msg.sent || msg.createdAt;

    if (!t) return "";

    if (typeof t === "string" && /^\d+$/.test(t)) t = Number(t);
    if (typeof t === "object" && typeof t.toDate === "function") t = t.toDate();
    if (typeof t === "number") t = new Date(t);
    if (typeof t === "string") t = new Date(t);

    return t.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const time = getTime();

  return (
    <div
      style={{
        textAlign: isMe ? "right" : "left",
        marginBottom: 15,
      }}
    >
      <div
        style={{
          display: "inline-block",
          padding: "8px 12px",
          borderRadius: 10,
          background: isMe ? "#dcf8c6" : "#fff",
          maxWidth: "70%",
          textAlign: "justify",
          position: "relative",
        }}
      >
        {msg.msg}

        <div
          style={{
            fontSize: 10,
            color: "#555",
            marginTop: 4,
            textAlign: "right",
          }}
        >
          {time}
        </div>
      </div>

      {isMe && (
        <div style={{ fontSize: 10, color: "#666", marginTop: 2 }}>
          {msg.read ? "✓✓ Read" : "✓ Sent"}
        </div>
      )}
    </div>
  );
};

export default MessageItem;
